<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        Aktions-Artikel
      </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper-new-listings" ref="contentWrapper">

      <v-virtual-scroll class="virtual-article-scroller" :item-height="itemHeight" :items="this.discountedArticles"
                        v-if="!isLoading" bench="3" ref="vscroll">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.id" @click="goToArticle(item.product.itemNo)">
            <v-list-item-content>
              <div class="article-card" :style="'height: '+(itemHeight - 12) +'px;'">
                <!--<v-img :src="loadProductImage(item.itemNo)" class="article-card__image"/>-->
                <v-img :src="baseUrl + 'storage/webps/'+ (item.product.itemNo.indexOf('-') > -1 ? item.product.itemNo.substr(0, item.product.itemNo.indexOf('-')) : item.product.itemNo)+'.webp'"
                       lazy-src=""
                       contain
                       class="article-card__image"
                />
                <div class="article-card__desc">
                  {{ item.product.description }}
                </div>
                <div class="article-card__itemNo">
                  Artikelnummer: {{ item.product.itemNo }}
                </div>
                <div class="article-card__status" v-if="item.product.availability === 'G'">
                  <div class="articleAvailable"></div>
                  <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                </div>
                <div class="article-card__status" v-if="item.product.availability === 'R'">
                  <div class="articleNotAvailable"></div>
                  <span class="articleStatusNotAvailable"
                        v-if="!item.product.delisted"
                  >
                        Artikel ist derzeit nicht lieferbar
                      </span>
                  <span class="articleStatusNotAvailable"
                        v-if="item.product.delisted"
                  >
                        Artikel ist ausgelistet
                      </span>
                </div>
                <div class="article-card__status" v-if="item.product.availability === 'Y'">
                  <div class="articlePending"></div>
                  <span class="articleStatusPending">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                </div>

                <div class="discountRibbonWrap no-col"
                >
                  <div class="discountRibbon">
                  </div>
                  <div class="discountRibbonContent">
                    <span class="ribbonText">Aktion</span>
                  </div>
                </div>

                <div style="grid-row-start: 4;grid-column-start: 2; grid-column-end: 2; margin-top: 10px;">
                  <div class="article-card__price-main" v-if="getPrice(item) && (getPermissions && getPermissions.indexOf('PRODSTANDARD') > -1)">
                    {{ getPrice(item) | parsePrice3Digits }} €

                    <span class="article-card__price-uvp" v-if="getUVP(item)">
                    UVP: {{ getUVP(item) | parsePrice2Digits }} €
                  </span>
                  </div>
                  <div v-if="(getPermissions && getPermissions.indexOf('LAGER') > -1)" class="article-card__shelf_no" :style="'margin-top: '+(getPermissions && getPermissions.indexOf('PRODSTANDARD') > -1 ? '15px;' : '')">
                    <strong>Lagerplatz:</strong> <span>{{item.shelfNo ? item.shelfNo : 'keine Daten vorhanden.'}}</span>
                  </div>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-virtual-scroll>
      <v-container class="lastArticlesWrapper loading" v-if="isLoading">

        <v-row
            class="articleCardRow"
        >
          <v-col cols="12"
                 class="articleCardCol"
                 v-for="index in 4"
                 :key="index"
          >
            <v-card class="articleCard"
                    elevation="0"
                    light
            >
              <v-list-item three-line class="skeletonWrapper__li">
                <v-skeleton-loader class="skeletonAvatar" type="avatar">

                </v-skeleton-loader>

                <v-list-item-content>
                  <v-container>
                    <v-row class="articleCard__details">
                      <v-col cols="12"
                             class="articleNameSmall"
                      >
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <div class="articleAdditionalInfoWrapper">
                        <v-col cols="12" class="pb-0 pt-2">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </div>
                      <v-col cols="12" class="articleStatus">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                      <v-col cols="12" class="pa-0 articlePriceMain">
                        <v-skeleton-loader type="text"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import axios from 'axios'
import router from '@/router'
import {api} from "@/config/api";

import scrollToPreviousPositionMixin from "@/app/productListing/mixins/scrollToPreviousPositionMixin";

export default {
  name: "discountedArticles",
  mixins: [scrollToPreviousPositionMixin],
  data() {
    return {
      discountedArticles: null,
      isLoading: true,
      baseUrl: api.url
    }
  },

  methods: {
    ...mapActions({
      setCategoryBreadcrumbs: 'setCategoryBreadcrumbs',
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      router.go(-1)
    },

    goToArticle(artNr) {
      this.setScrollPositionRef()
      this.$router.push({path: `/shop/article/${artNr}`})
    },

    loadProductImage(artNr) {
      return 'api/pic/'+artNr
    },

    getPrice(article) {
      return article.price
      /*
      if(article.price.length > 0) {
        return article.price[0].price
      }
      else if(article.default_price !== null && article.default_price !== null) {
        return article.default_price.uvp
      }
      else {
        return false
      }
       */
    },

    getUVP(article) {
      return article.uvp
      /*
      if(article.price.length > 0) {
        if(article.price[0].uvp !== null) {
          return article.price[0].uvp
        }
        else {
          if(article.default_price !== null) {
            if(article.default_price !== null) {
              return article.default_price.uvp
            }
          }else {
            return false
          }
        }
      }
      else if(article.default_price !== null) {
        if(article.default_price !== null) {
          return article.default_price.uvp
        }
      }
      else {
        return null
      }
      */
    }
  },

  computed: {
    ...mapGetters({
      getPermissions: 'getPermissions'
    }),
    itemHeight () {
      if(this.getPermissions && this.getPermissions.indexOf('PRODSTANDARD') > -1 && this.getPermissions && this.getPermissions.indexOf('LAGER') > -1) {
        return 216
      }
      return 181
    }
  },

  mounted() {
    this.setHeaderVisibility(false)

    axios.get('api/discountedProducts').then((res) => {
      this.discountedArticles = res.data
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.virtual-article-scroller {
  height: 100vh!important;
  padding-bottom: 235px;
}

.article-card {
  display: grid;
  grid-template-columns: 72px auto auto;
  grid-template-rows: 33px 39px 33px 40px;
  background-color: white;
  border-radius: 30px;
  overflow: hidden;
  padding: 12px 16px;
}

.article-card__image {
  height: 40px;
  width: 40px;
  background-color: gray;
  grid-row-start: 1;
  grid-row-end: 5;
  grid-column-start: 1;
  grid-column-end: 1;
  margin-top: 4px;
}

.article-card__desc {
  font-size: 16px;
  color: var(--igros-black);
  grid-row-start: 1;
  grid-column-start: 2;
  grid-column-end: 3;
  align-self: center;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.article-card__itemNo {
  font-size: 14px;
  color: var(--igros-black);
  grid-row-start: 2;
  grid-column-start: 2;
  grid-column-end: 3;
  align-self: center;
  text-align: left;
}

.article-card__status {
  font-size: 14px;
  color: var(--igros-black);
  grid-row-start: 3;
  grid-column-start: 2;
  grid-column-end: 3;
  align-self: center;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.article-card__price-main {
  font-size: 22px;
  color: #525252;
  grid-row-start: 4;
  grid-column-start: 2;
  grid-column-end: 2;
  font-weight: 700;
  align-self: center;
  text-align: left;
}

.article-card__price-uvp {
  font-size: 14px;
  color: var(--igros-grey)!important;
  font-weight: 400!important;
  grid-row-start: 4;
  grid-column-start: 3;
  grid-column-end: 3;
  align-self: center;
  text-align: left;
  margin-left: 5px;
}

.virtual-article-scroller .v-list-item{
  padding-left: 0;
  padding-right: 0;
}

.contentWrapper-new-listings {
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
.lastArticlesWrapper.loading .row.articleCardRow {
  display: unset;
}
.discountRibbonWrap.no-col {
  bottom: 35px;
}
.discountRibbonWrap.no-col .ribbonText {
  left: 0px;
}
.article-card__shelf_no {
  color: #525252;
  grid-row-start: 4;
  grid-column-start: 2;
  grid-column-end: 2;
  align-self: center;
  text-align: left;
}
.article-card__shelf_no strong {
  font-size: 20px;
}
.article-card__shelf_no span {
  font-size: 16px;
}
</style>
